import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: '客户资料',
  editTitle: '客户资料',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '标题',
      prop: 'noticeTitle',
      search: true,
      maxlength:64,
      searchOrder: 1000,
      searchRules: [
        {
          max: 15,
          message: '最多输入15个字符',
          trigger: ['blur', 'change'],
        },
      ],
    },
    {
      label: '发文部门',
      prop: 'signDeptVO',
      type: 'select',
      filterable: true,
      multiple: true,
      addDisplay: true,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      hide: true,
      dicData: [],
      props: {
        label: 'postName',
        value: 'id',
      },
    },

    {
      label: '签发时间',
      prop: 'signTimeS',
      type: 'daterange',
      search: true,
      hide: true,
      searchRange: true,
      display: false,
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    {
      label: '发文字号',
      prop: 'wordSize',
      span: 24,
      display: false,
    },
    {
      label: '发文部门',
      prop: 'postName',
      span: 24,
      display: false,
    },
    {
      label: '发送时间',
      width: 90,
      prop: 'createNoticeTime',
      type: 'input',
    },
    {
      label: '发送给',
      minWidth:120,
      prop: 'toDeptName',
      span: 24,
      display: false,
      overHidden: true,
      showOverflowTooltip: true,
    },
    {
      label: '签发时间',
      width: 90,
      prop: 'signTime',
      type: 'input',
    },
    {
      label: '是否签发',
      prop: 'signStatus',
      display: false,
      type: 'select',
      search: true,
      dicData: [
        {
          label: '未签发',
          value: 0,
        },
        {
          label: '已签发',
          value: 1,
        },
      ],
    },
  ],
};
